import React from 'react';

function OrderForm() {
  return <div>OrderForm</div>;
}

export default OrderForm;
